import { useCallback, useRef } from 'react';
import _ from 'lodash';
import today from 'src/common/utils/today';

const resolveAttachableDocuments = (contactDocuments, contactId) => (
  !_.isEmpty(contactDocuments) &&
  _.get(contactDocuments, [contactId, 'data'], [])
    .map((doc) => ({
      attached: false,
      document: doc,
    }))
);

const buildInitialValues = ({
  assistanceRequest,
  contactDocuments,
  contactId,
  defaultProgram,
  hasGroupLicense,
  hasNetworkLicense,
  networks,
}) => {
  const attachableDocuments = resolveAttachableDocuments(contactDocuments, contactId);
  const initialValues = {
    case_type: (hasGroupLicense && !hasNetworkLicense) ? 'org_case' : undefined,
    network: networks.length === 1 ? _.get(networks, '[0]') : undefined,
    program_entry: today(),
    program: defaultProgram || undefined,
    authorizationRequest: {
      amount_requested: '',
      service_start: '',
      service_end: '',
    },
    service_case: {
      attachableDocuments: attachableDocuments || [],
      description: _.get(assistanceRequest, 'description', ''),
      oonCase: {
        selected: [],
      },
      oonGroups: [],
    },
  };

  return Object.keys(initialValues).reduce((acc, key) => {
    acc[key] = initialValues[key];
    return acc;
  }, {});
};

export const useAddCaseDetailsInitialValues = ({
  assistanceRequest,
  caseDetailsValues,
  contactDocuments,
  contactId,
  defaultProgram,
  hasGroupLicense,
  hasNetworkLicense,
  networks,
  shouldInitializeForm,
}) => {
  const getInitialValues = useCallback(() => buildInitialValues({
    assistanceRequest,
    contactDocuments,
    contactId,
    defaultProgram,
    hasGroupLicense,
    hasNetworkLicense,
    networks,
  }), [
    assistanceRequest,
    contactDocuments,
    contactId,
    defaultProgram,
    hasGroupLicense,
    hasNetworkLicense,
    networks,
  ]);

  const initialValuesRef = useRef();
  if (!initialValuesRef.current) {
    const baseInitialValues = getInitialValues();
    initialValuesRef.current = shouldInitializeForm ?
      baseInitialValues :
      _.merge({}, baseInitialValues, caseDetailsValues || {});
  }

  return {
    initialValues: initialValuesRef.current,
  };
};
